import React, { Fragment, useMemo } from "react"
import { checkPasswordStrength } from "../helpers/password_strength"


/**
 * PasswordStrengthMeter — shows a color bar + label + 1-2 short tips.
 * Advisory-only — never blocks submission.
 *
 * Props:
 *   - password: string (the password to evaluate)
 *   - showTips: boolean (default true — show the tips below the bar)
 */
const PasswordStrengthMeter = ({ password, showTips = true }) => {
	const result = useMemo(() => checkPasswordStrength(password), [password])

	if (!password) return null

	return (
		<Fragment>
			<div style={{ display: "flex", alignItems: "center", gap: "8px", margin: "4px 0" }}>
				<div style={{
					width: "100%",
					height: "6px",
					borderRadius: "3px",
					backgroundColor: "#444",
					overflow: "hidden",
				}}>
					<div style={{
						width: `${(result.score / 4) * 100}%`,
						height: "100%",
						backgroundColor: result.color,
						borderRadius: "3px",
						transition: "width 0.2s ease, background-color 0.2s ease",
					}} />
				</div>
				<span style={{
					fontSize: "13px",
					fontWeight: "bold",
					color: result.color,
					whiteSpace: "nowrap",
					minWidth: "70px",
				}}>
					{result.label}
				</span>
			</div>

			{showTips && result.tips.length > 0 ? (
				<div style={{ fontSize: "13px", color: "silver", marginTop: "2px" }}>
					{result.tips.map((t, i) => <div key={i}>• {t}</div>)}
				</div>
			) : null}
		</Fragment>
	)
}

export default PasswordStrengthMeter
